import { createSelector, createFeatureSelector } from '@ngrx/store';
import { Session } from '../../models/session.interface';


export const selectSession = createFeatureSelector<Session>('session');

export const selectSessionUserState = createSelector(
  selectSession,
  ({ user }) => user
);
